import { Card, Empty } from 'antd';
export default function PrototypePage() {
  return <Card style={{marginTop:16}} title="原型设计"><Empty description="请在AI全流程中完成原型设计" /></Card>;
}
